import GSTIN from './Components/BillingAddress/GSTINcontainer';

export { gstinSubmit } from './gstinSubmit';
export default GSTIN;
